import { Instance, types, flow, applySnapshot } from 'mobx-state-tree';
import {
	saveStudentProfile,
	getStudentProfile,
	getProfilebyStudent,
	getProfileForParent,
} from '@common/api/studentProfile';
import StudentModel from '../Users/Students/Student';
import MainGoal from '../Goals/MainGoal';

export const StrengthModel = types.model('StrengthModel', {
	id: types.identifierNumber,
	student_id: types.number,
	title: types.maybeNull(types.string),
	description: types.maybeNull(types.string),
});

export const IndividualityModel = types.model('IndividualityModel', {
	id: types.identifierNumber,
	student_id: types.number,
	hobbies: types.maybeNull(types.string),
	values: types.maybeNull(types.string),
	talents: types.maybeNull(types.string),
});

export const InterestModel = types.model('InterestModel', {
	id: types.identifierNumber,
	student_id: types.number,
	interests: types.maybeNull(types.string),
});

export const PersonalQualityModel = types.model('PersonalQualityModel', {
	id: types.identifierNumber,
	student_id: types.number,
	title: types.maybeNull(types.string),
	description: types.maybeNull(types.string),
});

const StudentProfile = types
	.compose(
		StudentModel,
		types.model({
			strength: types.maybeNull(StrengthModel),
			interest: types.maybeNull(InterestModel),
			personalQuality: types.maybeNull(PersonalQualityModel),
			individuality: types.maybeNull(IndividualityModel),
			mainGoal: types.maybeNull(MainGoal),
		}),
	)
	.named('StudentProfile')
	.volatile(() => ({
		loading: false,
		number: 0,
	}))
	.actions((self) => ({
		_fetch: getStudentProfile,
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield saveStudentProfile({
					student_id: self.id,
					...data,
				});
				applySnapshot(self, { ...self, ...result });
				// eslint-disable-next-line no-useless-catch
			} catch (e) {
				throw e;
			} finally {
				self.loading = false;
			}
		}),
		fetchStudent: flow(function* (isParent = false) {
			self.loading = true;
			try {
				const result = isParent
					? yield getProfileForParent(self.id)
					: yield getProfilebyStudent();
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export interface IStudentProfileModel extends Instance<typeof StudentProfile> { }

export default StudentProfile;
